import api from '../services/api';

const KEY = 'ref_attribution';
const WINDOW_MS = 30 * 24 * 3600 * 1000;

/**
 * 登录/注册成功后调用：本地存有未过期的短链归因(/r/:code 落地时写入)则尝试补绑。
 * 覆盖微信 OAuth 等不经过注册表单的路径；后端 /referral/bind 幂等
 * (已绑定→already_bound、注册超7天→400)，无归因记录时不发请求。
 */
export default async function bindPendingReferral() {
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return; }
  if (!saved?.code) return;
  if (Date.now() - (saved.ts || 0) >= WINDOW_MS) {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    return;
  }
  try {
    await api.post('/referral/bind', { code: saved.code });
    localStorage.removeItem(KEY); // 成功或 already_bound 均视为完成
  } catch (err) {
    // 服务端明确拒绝(超7天窗口/码失效)→ 清除,避免每次登录重发;网络错误保留待下次重试
    if (err?.response) {
      try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    }
  }
}
